import {ReactElement, ReactNode} from 'react';
import {
  ClipboardList,
  Contact,
  FileText,
  Globe,
  House,
  type LucideIcon,
  Mail,
  ShieldCheck,
  Signature,
  UserRound,
} from 'lucide-react';
import {FormSection, cn, type FormSectionVariant} from '@chekinapp/ui';

const GROUP_ICONS: Record<string, LucideIcon> = {
  nationality: Globe,
  legal_name: UserRound,
  personal_data: Contact,
  docs_info: FileText,
  contact_data: Mail,
  arrival_data: House,
  signature: Signature,
  clauses: ShieldCheck,
};

type Props = {
  title: string;
  children: ReactElement | ReactElement[] | ReactNode | undefined;
  centered?: boolean;
  groupName?: string;
  divided?: boolean;
  addon?: ReactNode;
  variant?: FormSectionVariant;
  columns?: 'auto' | 2;
};
export const FieldsGroup = ({
  title,
  children,
  groupName,
  divided,
  addon,
  variant = 'card',
  columns = 'auto',
}: Props) => {
  const Icon = (groupName && GROUP_ICONS[groupName]) || ClipboardList;

  return (
    <FormSection variant={variant} className="fields-group-card">
      <FormSection.Header
        className="fields-group-title flex-wrap gap-y-1"
        icon={<Icon />}
        addon={addon}
      >
        {title}
      </FormSection.Header>
      <FormSection.Body
        divided={divided}
        className={cn(
          'fields-group [--default-select-trigger-empty-bg:var(--chekin-color-white)] [--empty-field-background:var(--chekin-color-white)] [--field-label-font-weight:500] [--field-label-raised-font-weight:500] [--field-max-width:100%] [&_.form-field-wrapper]:!m-0 [&_.form-field-wrapper]:!w-full',
          !divided &&
            (columns === 2
              ? 'flex flex-row flex-wrap gap-x-3 gap-y-3.5'
              : 'grid grid-cols-[repeat(auto-fit,minmax(min(100%,15rem),1fr))]'),
        )}
      >
        {children}
      </FormSection.Body>
    </FormSection>
  );
};
